import "../styles/remote-stores.css";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect } from "react";
import ServiceController from "../services/service-controller";
import { Skeleton } from "primereact/skeleton";

export default function RemoteStores(props) {
	const { t } = useTranslation();
	const localizer = t;
	const serviceController = new ServiceController();
	const [isLoading, setIsLoading] = useState(false);
	const [stores, setStores] = useState([]);
	const [cateogryName, setCateogryName] = useState("");

	const getData = async function () {
		try {
			setIsLoading(true);

			let category = "";
			if (window.location.href.indexOf("?") > 0) {
				let urlParams = new URLSearchParams(window.location.href.split("?")[1]);
				category = urlParams.get("category");
			}

			switch (category) {
				case "consultation":
					setCateogryName("مراکز مشاوره ای");
					break;
				case "car":
					setCateogryName("خدمات خودرو");
					break;
				case "cosmetics":
					setCateogryName("آرایشی و بهداشتی");
					break;
			}

			const storesResult = await serviceController.getRemoteStores(
				category,
				""
			);
			if (storesResult.isSuccess === false) throw storesResult.message;
			setStores(storesResult.value);
		} catch (error) {
			alert(error.toString());
		}
		setIsLoading(false);
	};

	useEffect(() => {
		getData();
	}, []);

	return (
		<div>
			<h3>{cateogryName}</h3>
			{isLoading === true && (
				<>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
					<div className="flex gap-4 mb-4">
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
						<Skeleton height="15rem" className="w-3"></Skeleton>
					</div>
				</>
			)}
			<ul className="r-stores">
				{stores.map((item) => (
					<li>
						<a className="r-store" href={`/#/remote-store-details/?code=${item.code}`}>
							<img src={item.imageUrl} />
							<div>
								<h2>{item.name}</h2>
								<p>{item.offPercent} % </p>
							</div>
							<a href={`/#/remote-store-details/?code=${item.code}`}>
								مشاهده جزییات بیشتر...
							</a>
						</a>
					</li>
				))}
			</ul>
		</div>
	);
}
